import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	triggerLabelForAiWorkCreate: {
		id: 'software-backlog-panel.epic.epic-panel.epic-inline-card-create.trigger-label-for-ai-work-create',
		defaultMessage: 'Create work item or create from Confluence page',
		description: 'Trigger label to use AI Work Create in backlog',
	},
});
